import React from "react";
import moment from "moment";
import { InvoiceHeader } from "../common/InvoiceHeader";
import { InvoiceFooter } from "../common/InvoiceFooterEquipment";

const STATUS_LABEL = {
  requested: "Requested",
  approved: "Approved",
  processing: "Processing",
  delivered: "Delivered",
};

const ServiceRequestTable = ({ list }) => (
  <div className="p-3">
    <div className="text-center py-1 mb-2 border-b-2 border-gray-400">
      <div className="font-bold text-sm tracking-widest uppercase">Service Request</div>
      <div className="text-[10px] text-gray-600 mt-0.5">
        Status: <span className="font-semibold">{STATUS_LABEL[list[0]?.status] || list[0]?.status || "—"}</span>
      </div>
    </div>
    <table className="w-full border border-gray-400 text-[10px]">
      <thead className="bg-gray-100">
        <tr>
          <th className="border border-gray-300 p-1 text-center w-6">#</th>
          <th className="border border-gray-300 p-1 text-left">Branch Name</th>
          <th className="border border-gray-300 p-1 text-left">Receiver Name</th>
          <th className="border border-gray-300 p-1 text-left">Service Type</th>
          <th className="border border-gray-300 p-1 text-left">Prepared By</th>
          <th className="border border-gray-300 p-1 text-left">Requested By / At</th>
          <th className="border border-gray-300 p-1 text-left">Status Updated By / At</th>
          <th className="border border-gray-300 p-1 text-left">Parts Used</th>
        </tr>
      </thead>
      <tbody>
        {list.map((data, index) => (
          <tr key={data._id || index} className={index % 2 === 0 ? "" : "bg-gray-50"}>
            <td className="border border-gray-300 p-1 text-center align-top">{index + 1}</td>
            <td className="border border-gray-300 p-1 align-top">{data?.branchName || "—"}</td>
            <td className="border border-gray-300 p-1 align-top">{data?.receiverName || "—"}</td>
            <td className="border border-gray-300 p-1 align-top">
              <div>{data?.serviceType || "—"}</div>
              {data?.description && (
                <div className="text-gray-500">{data.description}</div>
              )}
            </td>
            <td className="border border-gray-300 p-1 align-top">{data?.preparedBy || "—"}</td>
            <td className="border border-gray-300 p-1 align-top">
              <div>{data?.requestedByName || "—"}</div>
              <div className="text-gray-500 whitespace-nowrap">
                {data?.requestedAt ? moment(data.requestedAt).format("DD/MM/YY h:mm A") : "—"}
              </div>
            </td>
            <td className="border border-gray-300 p-1 align-top">
              <div>{data?.statusUpdatedByName || "—"}</div>
              <div className="text-gray-500 whitespace-nowrap">
                {data?.statusUpdatedAt ? moment(data.statusUpdatedAt).format("DD/MM/YY h:mm A") : "—"}
              </div>
            </td>
            <td className="border border-gray-300 p-1 align-top">
              {data?.parts?.length > 0 ? (
                <table className="w-full border border-gray-300 text-[9px]">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="border border-gray-300 p-0.5 text-center w-5">SL</th>
                      <th className="border border-gray-300 p-0.5 text-left">Category</th>
                      <th className="border border-gray-300 p-0.5 text-left">Part</th>
                      <th className="border border-gray-300 p-0.5 text-center w-8">Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.parts.map((part, i) => (
                      <tr key={i}>
                        <td className="border border-gray-300 p-0.5 text-center">{i + 1}</td>
                        <td className="border border-gray-300 p-0.5">{part.category}</td>
                        <td className="border border-gray-300 p-0.5">{part.productName}</td>
                        <td className="border border-gray-300 p-0.5 text-center">{part.quantity}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                "—"
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const ServiceRequestInvoice = React.forwardRef(({ items, data }, ref) => {
  const list = items || (data ? [data] : []);

  return (
    <div ref={ref} className="bg-gray-200 print:bg-white py-6 print:py-0">
      <style>{`
        @media print {
          @page { size: A4; margin: 10mm; }
          body { background: white; }
        }
      `}</style>

      <div className="w-[210mm] min-h-[297mm] mx-auto bg-white text-[12px] leading-relaxed">
        <InvoiceHeader />

        <ServiceRequestTable list={list} />

        <InvoiceFooter />
      </div>
    </div>
  );
});

export default ServiceRequestInvoice;
